import { render, staticRenderFns } from "./MaterialSearch.vue?vue&type=template&id=2003b792&"
import script from "./MaterialSearch.vue?vue&type=script&lang=js&"
export * from "./MaterialSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports